/* Compressed 3D campus, full-scale exhibit and court; load the GLB only when requested. */
(() => {
  document.querySelectorAll('[data-campus-pitch]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const image = root.querySelector('[data-campus-photo]'), stage = root.querySelector('[data-campus-stage]'), status = root.querySelector('[data-campus-status]'), controls = root.querySelector('[data-campus-controls]'), frame = root.querySelector('[data-campus-window]');
    const tabs = [...root.querySelectorAll('[data-campus-view]')], buttons = [...root.querySelectorAll('[data-campus-camera]')];
    let viewer, sequence = 0;
    const photos = {
      hero: ['Oregon campus activation with a full SLAP cornhole court beside the merchandise booth.', 'Campus courtyard concept · SLAP boards set 27 ft apart, front to front'],
      booth: ['The enlarged campus display and an Oregon Ducks flag ready for signing on the table.', 'A flush display, end-mounted MVP, kids’ mini toss and a corner table with two stools.'],
      detail: ['The Color Flagpole Bag and both lanyards inside the larger illuminated case.', 'Actual product models, shown at full scale.'],
      rear: ['Full-width capped locker enclosing the entire back of the campus display.', 'A flush 60-inch-wide rear locker with six storage doors and an end-mounted MVP flagpole.']
    };
    function camera(mode) {
      if (!viewer) return;
      const narrow = root.clientWidth < 700;
      const presets = {
        whole: ['2.0m 0.7m -3.0m', narrow ? '0deg 48deg 33m' : '25deg 62deg 30m'],
        booth: ['-1.03m 1.30m 0.9m', `5deg 80deg ${narrow ? 14 : 8}m`],
        kids: ['-3.10m 0.15m 1.45m', `0deg 45deg ${narrow ? 5.2 : 4.2}m`],
        court: ['4.83m 0.05m -2.36m', `0deg 28deg ${narrow ? 32 : 24}m`],
        detail: ['0.81m 0.67m -0.10m', '12deg 82deg 3m'],
        signing: ['-1.83m 0.79m 1.97m', '0deg 35deg 0.75m'],
        rear: ['0.23m 1.03m -0.45m', `170deg 72deg ${narrow ? 6 : 4.8}m`]
      };
      const p=presets[mode] || presets.whole;
      viewer.setAttribute('camera-target',p[0]);viewer.setAttribute('camera-orbit',p[1]);
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.campusCamera===mode)));
    }
    async function show(mode) {
      const request = ++sequence;
      tabs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.campusView===mode)));
      if (mode !== 'model') {
        viewer?.remove();viewer=null;stage.hidden=true;frame.hidden=true;image.hidden=false;controls.hidden=true;
        image.src=root.dataset[mode];image.alt=photos[mode][0];image.classList.toggle('is-detail',mode==='detail');status.textContent=photos[mode][1];return;
      }
      image.hidden=true;stage.hidden=false;frame.hidden=false;status.textContent='Loading the lightweight 3D courtyard…';
      try {
        if (!customElements.get('model-viewer')) await import(root.dataset.viewer);
        if(request!==sequence)return;
        viewer=document.createElement('model-viewer');
        const attrs={src:root.dataset.model,alt:'Interactive 3D courtyard with a flush bookstore display, locker-mounted flagpole, Ducks signing table, kids mini toss, corner seating and SLAP court','camera-controls':'','touch-action':'pan-y','field-of-view':'35deg','min-camera-orbit':'auto 8deg 0.5m','max-camera-orbit':'auto 87deg 48m','interaction-prompt':'none','shadow-intensity':'0.6','shadow-softness':'0.8',exposure:'1','environment-image':'neutral',loading:'eager'};
        Object.entries(attrs).forEach(([k,v])=>viewer.setAttribute(k,v));camera('booth');
        viewer.addEventListener('load',()=>{if(request!==sequence)return;status.textContent='Drag to explore · Pinch or scroll to zoom · Choose a view below';controls.hidden=false;},{once:true});
        viewer.addEventListener('error',()=>{if(request===sequence)status.textContent='The 3D scene could not load. The four photographs are still available.';},{once:true});
        stage.replaceChildren(viewer);
      } catch {if(request===sequence)status.textContent='The 3D viewer could not start. Choose a photograph above to explore the display.';}
    }
    tabs.forEach(b=>b.addEventListener('click',()=>show(b.dataset.campusView)));
    buttons.forEach(b=>b.addEventListener('click',()=>camera(b.dataset.campusCamera)));
    const initial = new URLSearchParams(location.search).get('campus');
    if (initial === '3d' || initial === 'model') show('model');
    else if (['booth', 'detail', 'rear'].includes(initial)) show(initial);
  });
})();
